<template>
    <div class="category bold">
        <div class="category-item" :class="{'active' : !brandId }"  @click="onChangeBrand(null)">
            全部
        </div>
        <div class="category-item" :class="{'active' : brandId === item.id}" v-for="(item, index) in brands" :key="index" @click="onChangeBrand(item)">
            {{item.title}}
        </div>
    </div>
</template>
<script>
import {getCategoryList} from '@/api/server/category'
export default {
    name: "brandComponent",
    props: {
     categoryId:{
       types: Number,
       required: true
     }
   },
    data () {
        return {
            cid: this.categoryId,
            brandId: null,
            brands: []
        }
    },
    computed: {
        nowCid () {
           return this.categoryId
        }
    },
    methods: {
        onChangeBrand (item) {
          if (item) {
            this.brandId = item.id
            this.$emit('changeBrand', item)
          } else {
            this.brandId = null
            this.$emit('changeBrand', null)
          }
        },
         _getBrands (cid = null) {
            let categoryId = cid ? cid : this.categoryId
            let query = {
                cid: categoryId,
            }
            getCategoryList(query).then( (res) => {
                if (res.code === 200) {
                this.brands = res.data
                }
            })
        },
        _reset () {
            this.cid = null
            this.brandId = null
            // this._getBrands()
        }
    },
    watch: {
        nowCid (newCid, oldCid) {
            let cid = newCid ? newCid: oldCid
            this.cid = cid
            this._getBrands(cid)
        },

    },
    mounted () {
        this._reset()
    }
}
</script>
<style lang="scss" scoped>
.bold {
    font-weight: bold;
}
.category {
    border-top: solid 1px #ddd;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    overflow: hidden;
    .category-item {
        margin-right: 10px;
        color: #9d9ea2;
    }
    .active {
        color: #e23435;
    }
}
</style>